<ng-container *ngIf="isAllowedToEdit && !isLoading; else notAllowed">
    <div class="columns">
        <div class="column is-1"></div>
        <div class="column is-10">
            <div class="columns">
                <div class="column is-fullwidth" style="text-align: center">
                    <h1 class="title" style="margin-top: 1em;">Nutzerverwaltung</h1>
                </div>
            </div>
            <div class="columns">
                <div class="column is-fullwidth">
                    <div class="management-container">
                        <table class="table is-hoverable is-fullwidth">
                            <thead style="background: #ddd;">
                                <tr>
                                    <th style="border-radius: 10px">
                                        <span>
                                            <a class="is-clickable color-white mr-4 is-vertical-middle" routerLink="/order">
                                                <fa-icon [icon]="faArrowLeft"></fa-icon>
                                            </a>
                                        </span>
                                        <span>Benutzergruppen</span>
                                        <span class="float-right">
                                            <button class="button is-link is-rounded is-small" (click)="addUserDialog()"><mat-icon class="space-right-5">supervisor_account</mat-icon>Nutzer hinzufügen</button>
                                        </span>
                                        <span class="float-right">
                                            <button class="button is-link is-rounded is-small" (click)="createUserGroup($event)"><mat-icon class="space-right-5">group_add</mat-icon>Gruppe hinzufügen</button>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let group of userGroupManagements; let i = index">
                                    <td>
                                        <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title class="is-fullwidth">
                                                        <div class="group-wrapper">
                                                            <mat-icon class="group-profile">group</mat-icon>
                                                            <div class="indicator" data-count="{{group.users.length}}">{{group.users.length}}</div>
                                                            <span>{{group.userGroup.name}}</span>
                                                        </div>
                                                    </mat-panel-title>
                                                    <mat-panel-description class="align-end">
                                                        <mat-icon (click)="editUserGroup($event, group.userGroup.id, i, false, true)">settings</mat-icon>
                                                    </mat-panel-description>
                                                </mat-expansion-panel-header>
                                                <div class="userList">
                                                    <table class="table is-hoverable is-fullwidth">
                                                        <tr *ngFor="let user of group.users">
                                                            <td class="user-cell">
                                                                <div class="group-wrapper">
                                                                    <mat-icon class="user-profile">person</mat-icon>
                                                                    <span>{{user.mail}}</span>
                                                                </div>
                                                            </td>
                                                            <td class="menu-cell">
                                                                <app-user-management-menu (onUserDisabled)="disableUser($event)" [groups]="userGroupManagements" [user]="user" [loginId]="companyLoginId"></app-user-management-menu>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div *ngIf="orphans.length > 0" class="columns">
                <div class="column is-fullwidth">
                    <div class="management-container">
                        <table class="table is-hoverable is-fullwidth">
                            <thead style="background: #ddd;">
                                <tr>
                                    <th style="border-bottom-left-radius: 10px; border-top-left-radius: 10px">Nutzer ohne Gruppe</th>
                                    <th style="border-bottom-right-radius: 10px; border-top-right-radius: 10px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of orphans">
                                    <td class="user-cell">
                                        <div class="group-wrapper">
                                            <mat-icon class="user-profile">person</mat-icon>
                                            <span>{{user.mail}}</span>
                                        </div>
                                    </td>
                                    <td class="menu-cell">
                                        <app-user-management-menu style="padding-right: calc(0.75em + 24px) !important;" (onUserDisabled)="disableUser($event)" [groups]="userGroupManagements" [orphans]="orphans" [user]="user" [loginId]="companyLoginId"></app-user-management-menu>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-fullwidth">
                    <div class="management-container">
                        <table class="table is-fullwidth">
                            <thead style="background: #ddd;">
                                <tr>
                                    <th style="border-radius: 10px">Offene Anfragen/Einladungen</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><app-invites-list [invites]="openUserGroupInvites"></app-invites-list></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-1"></div>
    </div>
</ng-container>
<ng-template #notAllowed>
    <div *ngIf="!isLoading" class="no-permissions">
        <mat-card appearance="outlined" class="centered">
            <mat-card-header>
                <mat-card-title>
                    <span>Unzureichende Berechtigungen</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>
                    Sie verfügen nicht über die notwendigen Berechtigungen, um die Nutzergruppen verwalten zu können.
                </p>
                <p>
                    Bitte wenden Sie sich an den Administrator Ihrer Gesellschaft.
                </p>
            </mat-card-content>
        </mat-card>
    </div>
</ng-template>
